import { combineReducers } from 'redux';

import UncloseDay from './uncloseday/reducer';

export default combineReducers({
  UncloseDay,
});



// WEBPACK FOOTER //
// ./src/pages/uncloseday/state/reducer.js